import { observable } from 'mobx';

export type HotelPriceDetailResponseArgs = {
  nightly_rate: number;
  tax_and_service_fee?: number;
};

export type HotelPriceDetailArgs = {
  nightlyRate: number;
  taxAndServiceFee?: number;
};

export const convertHotelPriceDetailResponseToArgs = (response: HotelPriceDetailResponseArgs) => {
  const args: HotelPriceDetailArgs = {
    nightlyRate: response.nightly_rate,
    taxAndServiceFee: response.tax_and_service_fee
  };
  return args;
};

export default class HotelPriceDetail {
  @observable nightlyRate: number;
  @observable taxAndServiceFee?: number;

  constructor(args: HotelPriceDetailArgs) {
    this.nightlyRate = args.nightlyRate;
    this.taxAndServiceFee = args.taxAndServiceFee;
  }
}
